import React from 'react';
import { Building2, LogOut, User } from 'lucide-react';

const AdminHeader = ({ userName, onSignOut }) => {
  return (
    <header className="bg-card border-b border-border shadow-sm sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-3 sm:px-6 py-3 sm:py-4">
        <div className="flex items-center justify-between gap-2 sm:gap-4">
          <div className="flex items-center gap-2 sm:gap-4 min-w-0">
            <div className="flex items-center gap-2 sm:gap-3">
              <div className="p-2 sm:p-2.5 bg-primary rounded-lg sm:rounded-xl flex-shrink-0">
                <Building2 className="h-5 w-5 sm:h-6 sm:w-6 text-primary-foreground" />
              </div>
              <div className="min-w-0">
                <h1 className="text-lg sm:text-xl font-bold text-foreground truncate">
                  CTOBRA Admin
                </h1>
                <p className="text-xs sm:text-sm text-muted-foreground hidden sm:block">
                  Sistema de Gestão
                </p>
              </div>
            </div>
          </div>

          <div className="flex items-center gap-2 sm:gap-4 flex-shrink-0">
            <div className="hidden md:flex items-center gap-2 sm:gap-3 px-3 sm:px-4 py-2 sm:py-2.5 bg-muted rounded-lg sm:rounded-xl border border-border">
              <User className="h-3.5 w-3.5 sm:h-4 sm:w-4 text-muted-foreground flex-shrink-0" />
              <span className="text-xs sm:text-sm font-medium text-foreground truncate max-w-[120px] sm:max-w-[200px]">
                {userName}
              </span>
            </div>
            <button
              onClick={onSignOut}
              className="flex items-center gap-1.5 sm:gap-2 px-3 sm:px-4 py-2 sm:py-2.5 bg-destructive/10 hover:bg-destructive/20 text-destructive rounded-lg sm:rounded-xl transition-colors border border-destructive/20 text-sm sm:text-base"
            >
              <LogOut className="h-3.5 w-3.5 sm:h-4 sm:w-4" />
              <span className="hidden sm:inline font-medium">Sair</span>
            </button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default AdminHeader;